import { Component, Input, OnInit } from "@angular/core";
import { PlayerShortDto } from "app/models";

@Component({
    selector: 'next-fixture-ban',
    templateUrl: './next-fixture-ban.component.html',
    styleUrls: ['./next-fixture-ban.component.scss'],
})
export class NextFixtureBan implements OnInit {
    @Input() homePlayers: PlayerShortDto[];
    @Input() visitorPlayers: PlayerShortDto[];
    
    ngOnInit(): void {
        
    }

    getFirstName(name: string) {
        if (!name) return null;

        return name[0] + ".";
    }
}